'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Popup = require('@cobalt/react-popup');
var reactPortalProvider = require('@cobalt/react-portal-provider');
var usePosition = require('@cobalt/react-position-hook');
var Box = require('@cobalt/react-box');
var reactTypography = require('@cobalt/react-typography');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Popup__default = /*#__PURE__*/_interopDefaultLegacy(Popup);
var usePosition__default = /*#__PURE__*/_interopDefaultLegacy(usePosition);
var Box__default = /*#__PURE__*/_interopDefaultLegacy(Box);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

(function (PositionLeftTop) {
  PositionLeftTop["origin"] = "NW";
  PositionLeftTop["direction"] = "NE";
  PositionLeftTop[PositionLeftTop["autoGap"] = 10] = "autoGap";
})(exports.PositionLeftTop || (exports.PositionLeftTop = {}));

(function (PositionCenterTop) {
  PositionCenterTop["origin"] = "N";
  PositionCenterTop["direction"] = "N";
  PositionCenterTop[PositionCenterTop["autoGap"] = 10] = "autoGap";
})(exports.PositionCenterTop || (exports.PositionCenterTop = {}));

(function (PositionRightTop) {
  PositionRightTop["origin"] = "NE";
  PositionRightTop["direction"] = "NW";
  PositionRightTop[PositionRightTop["autoGap"] = 10] = "autoGap";
})(exports.PositionRightTop || (exports.PositionRightTop = {}));

(function (PositionLeftCenter) {
  PositionLeftCenter["origin"] = "W";
  PositionLeftCenter["direction"] = "W";
  PositionLeftCenter[PositionLeftCenter["autoGap"] = 10] = "autoGap";
})(exports.PositionLeftCenter || (exports.PositionLeftCenter = {}));

(function (PositionRightCenter) {
  PositionRightCenter["origin"] = "E";
  PositionRightCenter["direction"] = "E";
  PositionRightCenter[PositionRightCenter["autoGap"] = 10] = "autoGap";
})(exports.PositionRightCenter || (exports.PositionRightCenter = {}));

(function (PositionLeftBottom) {
  PositionLeftBottom["origin"] = "SW";
  PositionLeftBottom["direction"] = "SE";
  PositionLeftBottom[PositionLeftBottom["autoGap"] = 10] = "autoGap";
})(exports.PositionLeftBottom || (exports.PositionLeftBottom = {}));

(function (PositionCenterBottom) {
  PositionCenterBottom["origin"] = "S";
  PositionCenterBottom["direction"] = "S";
  PositionCenterBottom[PositionCenterBottom["autoGap"] = 10] = "autoGap";
})(exports.PositionCenterBottom || (exports.PositionCenterBottom = {}));

(function (PositionRightBottom) {
  PositionRightBottom["origin"] = "SE";
  PositionRightBottom["direction"] = "SW";
  PositionRightBottom[PositionRightBottom["autoGap"] = 10] = "autoGap";
})(exports.PositionRightBottom || (exports.PositionRightBottom = {}));

const Tooltip = ({
  label,
  position = exports.PositionCenterTop,
  variation = "light",
  disabled = false,
  children,
  ...props
}) => {
  const ref = React.useRef(null);
  const [visible, toggleVisible] = React.useState(false);
  const {
    position: positionStyle
  } = usePosition__default['default'](ref === null || ref === void 0 ? void 0 : ref.current, position);
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].cloneElement(children, {
    forwardedRef: ref,
    onMouseEnter: () => toggleVisible(true),
    onMouseLeave: () => toggleVisible(false)
  }), /*#__PURE__*/React__default['default'].createElement(reactPortalProvider.Portal, null, /*#__PURE__*/React__default['default'].createElement(Popup__default['default'], _extends({
    shape: "compact",
    visible: visible && !disabled && !!positionStyle,
    style: { ...positionStyle
    },
    variation: variation
  }, props), /*#__PURE__*/React__default['default'].createElement(Box__default['default'], {
    padding: 2
  }, /*#__PURE__*/React__default['default'].createElement(reactTypography.Text, null, label)))));
};

exports.default = Tooltip;
